import { RequestMethod } from '~packages/json-api/client';

import EpkModuleApiService from './EpkModuleApiService';

export interface Item {
  [k: string]: unknown;
}

export interface IParams {
  /** Field in _data_ item */
  fieldIndex?: string;
  /** Field in _data_ item */
  fieldLevel?: string;
  isModeStorage?: boolean;
  pathPreload?: string;
  requestMethodPreload?: string;
}

export default class CascadeModuleApiService<
  T extends Item
> extends EpkModuleApiService {
  fieldIndex: string;
  fieldLevel: string;
  isModeStorage: boolean;
  levelMax: number;
  pathPreload: string;
  requestMethodPreload: string;
  storage: T[] = [];

  constructor({
    fieldIndex = '_index',
    fieldLevel = '$_level',
    isModeStorage,
    pathPreload,
    requestMethodPreload = RequestMethod.GET,
    ...params
  }: IParams) {
    super({ ...params });

    this.fieldIndex = fieldIndex;
    this.fieldLevel = fieldLevel;
    this.isModeStorage = isModeStorage || false;
    this.pathPreload = pathPreload || this.pathFetchAll;
    this.requestMethodPreload = requestMethodPreload;

    this.levelMax = 0;
  }

  async preload(
    path = '',
    params?: Record<string, unknown>,
    ntSetLevelMax = this.isModeStorage
  ) {
    const response = await this._sendRequest(
      `${this.pathPreload}${path}`,
      params,
      { method: this.requestMethodPreload },
      { method: 'preload' }
    );

    const data = response.response.data as T[];

    /*  */
    if (ntSetLevelMax) {
      const fLvl = this.fieldLevel;
      let lvlMax = this.levelMax;
      data.forEach(i => {
        const iLvl = i[fLvl] as number;
        if (iLvl > lvlMax) lvlMax = iLvl;
      });
      this.levelMax = lvlMax;
    }

    /*  */
    this.storage = data;

    return response;
  }

  next(_item?: T, lvlNext = 0, idx = 0) {
    if (this.isModeStorage) {
      const storageItems = this.storage;
      const data: T[] = [];

      /* `processNext` variation */
      const fieldLevel = this.fieldLevel;
      let itemCurr = storageItems[++idx];
      while (itemCurr && itemCurr[fieldLevel] === lvlNext) {
        data.push(storageItems[idx]);
        itemCurr = storageItems[++idx];
      }

      return {
        status: true,
        response: {
          data,
          meta: {
            levelMax: this.levelMax,
          },
        },
        errors: [],
      };
    } else {
      // TODO: impl
      return {
        status: true,
        response: {
          data: [],
        },
      };
    }
  }
}
